import { render } from "./comming-soon.vue?vue&type=template&id=757b0b42&scoped=true"
import script from "./comming-soon.vue?vue&type=script&lang=js"
export * from "./comming-soon.vue?vue&type=script&lang=js"

import "./comming-soon.vue?vue&type=style&index=0&id=757b0b42&scoped=true&lang=css"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757b0b42"]])

export default __exports__